var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-container"},[_c('ColorScalesHeader'),_c('div',{staticClass:"book-container"},[_c('BookMenu',{staticClass:"menu"}),_vm._m(0)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"article-container"},[_c('h1',[_vm._v("Color music scale development")])])
}]

export { render, staticRenderFns }